import { render, staticRenderFns } from "./DownLoadCard.vue?vue&type=template&id=132bfd73&scoped=true&"
import script from "./DownLoadCard.vue?vue&type=script&lang=js&"
export * from "./DownLoadCard.vue?vue&type=script&lang=js&"
import style0 from "./DownLoadCard.vue?vue&type=style&index=0&id=132bfd73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132bfd73",
  null
  
)

export default component.exports